module.exports = __webpack_public_path__ + "static/media/left_ailgn_05.af813a64.jpeg";